<template>
  <div class="stage">
    <div class="blobs" aria-hidden="true">
      <span class="blob b1"></span>
      <span class="blob b2"></span>
      <span class="blob b3"></span>
      <span class="blob b4"></span>
    </div>

    <div class="stage-inner">
      <p class="kicker">Rainbow Manager</p>
      <h1>{{ t('consultation') }}</h1>
      <p class="lead">{{ t('revealYourInherentElegance') }}</p>

      <article class="card">
        <p>
          <strong>{{ t('haveYouEverContemplated') }}</strong> {{ t('whyCertainHues') }}
        </p>
        <p>{{ t('greedy') }}</p>
        <p class="goal">{{ t('myGoal') }}</p>
      </article>

      <h2>{{ t('whatWilGain') }}</h2>
      <div class="benefits">
        <article class="card">
          <h3>{{ t('recoveredTime') }}</h3>
          <p>{{ t('youWillCeaseAcquiring') }}</p>
        </article>
        <article class="card">
          <h3>{{ t('assuredSelection') }}</h3>
          <p>{{ t('youWillPossessPreciseClarity') }}</p>
        </article>
        <article class="card">
          <h3>{{ t('cohesiveHarmonious') }}</h3>
          <p>{{ t('youWillAppearMore') }}</p>
        </article>
      </div>

      <article class="card cta">
        <h2>{{ t('bidFarewell') }}</h2>
        <p>{{ t('togetherWeWillDiscover') }}</p>
        <div class="actions">
          <app-button
            :icon="['fas', 'eye']"
            title="demoLookbook"
            @click="openPdfModal"
          ></app-button>
          <app-button
            raised
            severity="gradient"
            :icon="['fab', 'telegram']"
            title="connectViaTelegram"
            @click="openTelegram"
          ></app-button>
        </div>
      </article>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppButton from '@/shared/components/AppButton.vue';
import { useI18n } from 'vue-i18n';
import { openDialog } from '@/shared/components/dialog/services/dialog.service';
import AppPdfPreview from '@/shared/components/AppPdfPreview.vue';

export default defineComponent({
  components: { AppButton },
  setup() {
    const { t } = useI18n();
    const openTelegram = () => {
      const contacts = {
        telegram: '@Yuliyaa_S',
      };

      try {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (isMobile) {
          window.location.href = `tg://resolve?domain=${contacts.telegram.replace('@', '')}`;
          setTimeout(() => {
            window.open(`https://t.me/${contacts.telegram.replace('@', '')}`, '_blank');
          }, 500);
        } else {
          window.open(`https://t.me/${contacts.telegram.replace('@', '')}`, '_blank');
        }
      } catch (error) {
        console.error('Error opening Telegram:', error);
        window.open(`https://t.me/${contacts.telegram.replace('@', '')}`, '_blank');
      }
    };
    const openPdfModal = () => {
      openDialog(AppPdfPreview, {});
    };

    return {
      openTelegram,
      t,
      openPdfModal,
    };
  },
});
</script>

<style scoped lang="scss">
.stage {
  position: relative;
  isolation: isolate;
  min-height: 100%;
  display: flex;
  justify-content: center;
  padding: 32px 28px 64px;
  color: #f6f3ee;
  background: #141018;
}

.blobs {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.55;
  animation: blob-drift 22s ease-in-out infinite;
}

.b1 {
  width: 48vw;
  height: 48vw;
  left: -8%;
  top: -18%;
  background: #fa496e;
  animation-duration: 18s;
}

.b2 {
  width: 42vw;
  height: 42vw;
  right: -10%;
  top: 8%;
  background: #a67eff;
  animation-duration: 24s;
  animation-direction: reverse;
}

.b3 {
  width: 38vw;
  height: 38vw;
  left: 18%;
  bottom: -16%;
  background: #52dbff;
  animation-duration: 20s;
}

.b4 {
  width: 28vw;
  height: 28vw;
  right: 18%;
  bottom: 8%;
  background: #a67eff;
  opacity: 0.7;
  animation-duration: 16s;
  animation-direction: reverse;
}

.stage-inner {
  position: relative;
  z-index: 1;
  width: min(760px, 100%);
  text-align: center;
}

.kicker {
  margin: 0 0 16px;
  font-size: 11px;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: rgba(246, 243, 238, 0.7);
}

h1 {
  margin: 0 auto 12px;
  font-size: clamp(2.2rem, 6vw, 3.4rem);
  font-weight: 600;
  line-height: 1.05;
  letter-spacing: -0.04em;
}

.lead {
  margin: 0 auto 28px;
  max-width: 28ch;
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.78);
}

.stage-inner > h2 {
  margin: 28px 0 14px;
  font-size: clamp(1.2rem, 2.4vw, 1.5rem);
  font-weight: 600;
  letter-spacing: -0.03em;
}

.card {
  margin: 0 0 16px;
  padding: 24px;
  border: 1px solid rgba(246, 243, 238, 0.16);
  border-radius: 20px;
  background: rgba(20, 16, 24, 0.28);
  text-align: left;
}

.card p {
  margin: 0 0 12px;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.78);
}

.card p:last-child {
  margin-bottom: 0;
}

.card .goal {
  color: #f6f3ee;
}

.benefits {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 8px;
}

.benefits .card {
  margin: 0;
}

.card h2,
.card h3 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.cta {
  margin-top: 8px;
}

.cta h2 {
  font-size: clamp(1.2rem, 2.4vw, 1.5rem);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 18px;
}

:deep(.btn) {
  height: 46px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

:deep(.btn.success) {
  color: #141018;
  background: #f6f3ee;
}

:deep(.btn:not(.raised, .gradient):hover) {
  color: #141018;
  background: #fff;
}

:deep(.btn.gradient),
:deep(.btn.raised) {
  color: #f6f3ee;
  background: transparent;
  border: 1px solid rgba(246, 243, 238, 0.28);
  box-shadow: none;
}

:deep(.btn.gradient:hover),
:deep(.btn.raised:hover) {
  background: rgba(246, 243, 238, 0.08);
}

:deep(.btn.gradient .btn-icon),
:deep(.btn.raised .btn-icon),
:deep(.btn.gradient .btn-title),
:deep(.btn.raised .btn-title) {
  color: #f6f3ee;
}

:deep(.btn.raised:active) {
  box-shadow: none;
}

@keyframes blob-drift {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(5%, 7%) scale(1.08);
  }
}

@media (max-width: 700px) {
  .stage {
    padding: 20px 18px 40px;
  }

  .card {
    padding: 20px 16px;
  }

  .benefits {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .blob {
    animation: none;
  }
}
</style>
